module.exports = __webpack_public_path__ + "img/30.85a2aaa4.png";